import { render } from "./RightBuoy.vue?vue&type=template&id=ed3123fe&scoped=true"
import script from "./RightBuoy.vue?vue&type=script&lang=js"
export * from "./RightBuoy.vue?vue&type=script&lang=js"

import "./RightBuoy.vue?vue&type=style&index=0&id=ed3123fe&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3123fe"]])

export default __exports__